import React from 'react'

const ArrowDownRightCircle = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM5.854 5.146C5.76011 5.05211 5.63278 4.99937 5.5 4.99937C5.36722 4.99937 5.23989 5.05211 5.146 5.146C5.05211 5.23989 4.99937 5.36722 4.99937 5.5C4.99937 5.63278 5.05211 5.76011 5.146 5.854L9.243 9.95H6.475C6.34239 9.95 6.21521 10.0027 6.12145 10.0964C6.02768 10.1902 5.975 10.3174 5.975 10.45C5.975 10.5826 6.02768 10.7098 6.12145 10.8036C6.21521 10.8973 6.34239 10.95 6.475 10.95H10.45C10.5826 10.95 10.7098 10.8973 10.8036 10.8036C10.8973 10.7098 10.95 10.5826 10.95 10.45V6.475C10.95 6.34239 10.8973 6.21521 10.8036 6.12145C10.7098 6.02768 10.5826 5.975 10.45 5.975C10.3174 5.975 10.1902 6.02768 10.0964 6.12145C10.0027 6.21521 9.95 6.34239 9.95 6.475V9.243L5.854 5.146Z"
        fill="black"
      />
    </svg>
  )
}

export default ArrowDownRightCircle;
